export enum PopulationTypeEnum {
  GENERAL_V2,
  GENERAL_SEASON,
  GENERAL_PLAN,
  MERIT_SETTINGS,
  EQUITY_SETTINGS,
  EQUITY_SUB_SETTINGS,
  ALLOCATION_WORKFLOWS,
  BENCHMARK_SETTINGS,
  COMMERCIAL_ROUNDING,
  VALIDATION_SETTINGS,
  PLACEMENT_SETTINGS,
  INDIVIDUAL_MULTIPLIER,
  SECURITY_SETTINGS,
  SIMULATION_PERMISSIONS,
  POSITION_INFORMATION,
  SIGNATURE_AUTHORIZATION,
  ECL_EMPLOYEE,
  RESTRUCTURING_EMPLOYEE,
  NONE
}
